import MedicineBottle01Icon from "@hugeicons/core-free-icons/MedicineBottle01Icon";
import ShoppingCart01Icon from "@hugeicons/core-free-icons/ShoppingCart01Icon";
import UserMultipleIcon from "@hugeicons/core-free-icons/UserMultipleIcon";
import InjectionIcon from "@hugeicons/core-free-icons/InjectionIcon";
import { INVENTORY_ROLES } from "../constants/roles";

// Inventory Console nav.
//
// Promoted out of the Pharmacy Console 2026-09-30. Both screens lived at /v2/pharmacy/*
// only because that is where they were first built; once SUPER_INVENTORY existed they
// became unreachable for it — the pages were gated on PHARMACY_ROLES, so the role with the
// API grants had no way in. Same promotion Finance and Logistics already had.
//
// Procurement leads: it is the work queue (what to order today). Catalogue is the
// read-only medicine list and is consulted, not worked.
//
// Purchase-order pages (list + detail) are reached from inside Procurement, not from the
// sidebar — one nav entry for the whole workflow, as before.
export const INVENTORY_NAV = [
    { key: "procurement", label: "Procurement", path: "/v2/inventory/procurement", icon: ShoppingCart01Icon, roles: INVENTORY_ROLES },
    { key: "catalogue", label: "Medicine Catalogue", path: "/v2/inventory/catalogue", icon: MedicineBottle01Icon, roles: INVENTORY_ROLES },
    { key: "glp1", label: "GLP-1 Dashboard", path: "/v2/inventory/glp1", icon: InjectionIcon, roles: INVENTORY_ROLES },
    // Users — the legacy /users screen, reused as-is (see routes.jsx).
    { key: "users", label: "Users", path: "/v2/inventory/users", icon: UserMultipleIcon, roles: INVENTORY_ROLES },
];
